<template>
  <div class="editAdd identityauth certification">
    <van-notice-bar wrapable :scrollable="false" v-if="info.reason">
      <template #default>
        <b class="f15" style="color: #FF0000;">审核失败原因：</b>
        <p class="f14" style="color: #FF0000;">{{ info.reason }}</p>
      </template>
    </van-notice-bar>
    <article>
      <img class="title" src="/static/images/community/new-img/certfield.png" />
      <ul class="select">
        <li>
          <van-radio-group v-model="radio">
            <div
              class="options"
              v-for="item of certmanageList"
              :class="{ selected: radio == item.id }"
            >
              <van-radio :name="item.id" icon-size="0.2rem">
                <!--                <template #icon="props">-->
                <!--                  <img class="img-icon" :src="props.checked ? '/static/images/community/new-img/selected.png' : '/static/images/community/new-img/default.png'" />-->
                <!--                </template>-->
                <p class="f15">{{ item.territoryname }}</p>
                <span class="f14">{{ item.territorydesc }}</span>
              </van-radio>
            </div>
          </van-radio-group>
        </li>
      </ul>
      <img class="title" src="/static/images/community/new-img/assistcert.png" />
      <ul>
        <li>
          <van-uploader v-model="uploadcert">
            <img v-if="!uploadcert.length" src="/static/images/community/new-img/uploadcert.png" />
            <img v-if="uploadcert.length" src="/static/images/community/new-img/uploadcert1.png" />
            <div class="content">
              <img v-if="uploadcert.length" :src="uploadcert[0].content" />
            </div>
          </van-uploader>
        </li>
        <li>
          <van-uploader v-model="uploadimg">
            <img v-if="!uploadimg.length" src="/static/images/community/new-img/uploadimg.png" />
            <img v-if="uploadimg.length" src="/static/images/community/new-img/uploadimg1.png" />
            <div class="content">
              <img v-if="uploadimg.length" :src="uploadimg[0].content" />
            </div>
          </van-uploader>
        </li>
      </ul>
      <img class="title" src="/static/images/community/new-img/realnamecert.png" />
      <ul>
        <li class="idcard flex-ac">
          <input type="text" maxlength="30" v-model="realname" placeholder="请输入您的真实姓名" />
          <img
            v-if="realname"
            @click="realname = ''"
            class="close"
            src="/static/images/closex.png"
          />
        </li>
        <li class="idcard flex-ac">
          <input type="text" maxlength="25" v-model="cardid" placeholder="请输入您的身份证号" />
          <img v-if="cardid" @click="cardid = ''" class="close" src="/static/images/closex.png" />
        </li>
        <li>
          <van-uploader v-model="uploadperson">
            <img
              v-if="!uploadperson.length"
              src="/static/images/community/new-img/uploadperson.png"
            />
            <img
              v-if="uploadperson.length"
              src="/static/images/community/new-img/uploadperson1.png"
            />
            <div class="content">
              <img v-if="uploadperson.length" :src="uploadperson[0].content" />
            </div>
          </van-uploader>
        </li>
        <li>
          <van-uploader v-model="uploadidcard">
            <img
              v-if="!uploadidcard.length"
              src="/static/images/community/new-img/uploadidcard.png"
            />
            <img
              v-if="uploadidcard.length"
              src="/static/images/community/new-img/uploadidcard1.png"
            />
            <div class="content">
              <img v-if="uploadidcard.length" :src="uploadidcard[0].content" />
            </div>
          </van-uploader>
        </li>
      </ul>
    </article>
    <footer>
      <button class="btn" @click="submit">提交审核</button>
    </footer>
  </div>
</template>

<script>
import { isWeixin, fenxiang, isApp } from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'

export default {
  name: 'certification',
  data() {
    return {
      fileLen: 0,
      uploadcert: [],
      uploadimg: [],
      uploadperson: [],
      uploadidcard: [],
      datalist: [],
      cardid: '',
      realname: '',
      radio: '',
      certmanageList: [],
      info: {}
    }
  },
  mounted: function() {
    if (isWeixin()) {
      fenxiang({ path: 'certification' })
    }
    this.getData()
  },
  destroyed: function() {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    uploadcert(n) {
      if (n.length > 1) {
        this.uploadcert.splice(0, 1)
      }
    },
    uploadimg(n) {
      if (n.length > 1) {
        this.uploadimg.splice(0, 1)
      }
    },
    uploadperson(n) {
      if (n.length > 1) {
        this.uploadperson.splice(0, 1)
      }
    },
    uploadidcard(n) {
      if (n.length > 1) {
        this.uploadidcard.splice(0, 1)
      }
    }
  },
  methods: {
    getData: function() {
      var url = this.$ajax.getCertmanageList_URL,
        that = this,
        arg = isApp()
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          that.certmanageList = res.data.list
          if (arg == '') {
            fenxiang({
              title: encodeURIComponent(res.data.sharetitle),
              desc: encodeURIComponent(res.data.sharedesc),
              imgx: res.data.shareimg,
              path: 'communitycreator',
              dataStr: 'type=communitycreator'
            })
          } else if (arg.indexOf('xcx') >= 0) {
            var xcxObj = {
              type: 'communitycreator',
              title: encodeURIComponent(res.data.sharetitle),
              img: res.data.shareimg,
              link: path + 'static/wx/html/community-creator/creator.html?1=1' + arg
            }
            wx.miniProgram.postMessage({ data: xcxObj })
          }
        }
      })
      if (this.$route.query.verstatus == 3) {
        this.getData1()
      }
    },
    getData1: function() {
      // verstatus
      var url = this.$ajax.getCreatorApplyInfo_URL,
        that = this
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          that.info = res.data.data
          that.uploadcert = [{ content: that.info.cardfrontimg }]
          that.uploadimg = [{ content: that.info.fansimg }]
          that.uploadperson = [{ content: that.info.cardfrontimg }]
          that.uploadidcard = [{ content: that.info.cardhandimg }]
          that.realname = that.info.realname
          that.radio = that.info.territoryid
          that.cardid = that.info.cardid
        }
      })
    },
    afterRead: function(file) {
      console.log(file)
    },
    // 将base64转换为blob
    dataURLtoBlob: function(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function(n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
    cosUploadImage(filllist, file, index, format, type, fn) {
      console.log(file)
      if (
        (file.url && file.url.indexOf('https://') >= 0) ||
        (file.content && file.content.indexOf('https://') >= 0)
      ) {
        index++
        var path = file.url
          ? file.url.replace('Uploads/', '')
          : file.content.replace('Uploads/', '')
        if (type == 'imgpath') {
          path = file.url ? file.url.split('Uploads/')[1] : file.content.split('Uploads/')[1]
        } else {
          path = file.content
        }
        if (type == 'imgpath') {
          this.datalist.push(path)
        }
        if (index >= filllist.length) {
          if (typeof fn === 'function') {
            fn()
          }
        } else {
          this.cosUploadImage(filllist, filllist[index], index, format, type, function() {
            if (typeof fn === 'function') {
              fn()
            }
          })
        }
        return
      }
      var that = this
      that.$cos.uploadFile({
        key: '/certification_h5' + file.file.name,
        file: file.file,
        success: function(data) {
          if (type == 'imgpath') {
            that.datalist.push(data)
          }
          index++
          if (index >= filllist.length) {
            if (typeof fn === 'function') {
              fn()
            }
          }
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    uploadImage(filllist, file, index, format, type, fn) {
      if (
        (file.url && file.url.indexOf('https://') >= 0) ||
        (file.content && file.content.indexOf('https://') >= 0)
      ) {
        index++
        var path = file.url
          ? file.url.replace('Uploads/', '')
          : file.content.replace('Uploads/', '')
        if (type == 'imgpath') {
          path = file.url ? file.url.split('Uploads/')[1] : file.content.split('Uploads/')[1]
        } else {
          path = file.content
        }
        if (type == 'imgpath') {
          this.datalist.push(path)
        }
        if (index >= filllist.length) {
          if (typeof fn === 'function') {
            fn()
          }
        } else {
          this.uploadImage(filllist, filllist[index], index, format, type, function() {
            if (typeof fn === 'function') {
              fn()
            }
          })
        }
        return
      }
      var imgName = 'idcard'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      var url = this.$ajax.getOssWeb_URL
      var that = this
      this.$customRequestAjax(url).then(async (res) => {
        if (res.data.code === 200) {
          const { accessid, host, policy, signature, dir } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + format
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then((res) => {
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.imgUrl + `${dir}${str}`
              var path = `${dir}${str}`.replace('Uploads/', '')
              if (type == 'imgpath') {
                that.datalist.push(path)
              }
              index++
              if (index >= filllist.length) {
                if (typeof fn === 'function') {
                  fn()
                }
              }
            }
          })
        }
      })
    },
    submit: function() {
      if (this.radio == '') {
        this.$toast('请选择认证领域')
        return
      } else if (!this.uploadcert.length) {
        this.$toast('请上传奖杯证书、从业资格证')
        return
      } else if (!this.uploadimg.length) {
        this.$toast('请上传小红书/抖音后台粉丝量截图')
        return
      } else if (!this.cardid.trim()) {
        this.$toast('请输入您的真实姓名')
        return
      } else if (!this.realname.trim()) {
        this.$toast('请输入您的身份证号')
        return
      } else if (!this.uploadperson.length) {
        this.$toast('请上传人像面')
        return
      } else if (!this.uploadidcard.length) {
        this.$toast('请上传身份证手持照')
        return
      }
      this.$toast.loading({
        mask: true,
        message: '正在提交',
        duration: 0
      })
      this.fileLen = 0
      var that = this
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
      that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
        that.uploadcert,
        that.uploadcert[that.fileLen],
        that.fileLen,
        '.png',
        'imgpath',
        function() {
          that.fileLen = 0
          that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
            that.uploadimg,
            that.uploadimg[that.fileLen],
            that.fileLen,
            '.png',
            'imgpath',
            function() {
              that.fileLen = 0
              that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
                that.uploadperson,
                that.uploadperson[that.fileLen],
                that.fileLen,
                '.png',
                'imgpath',
                function() {
                  that.fileLen = 0
                  that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
                    that.uploadidcard,
                    that.uploadidcard[that.fileLen],
                    that.fileLen,
                    '.png',
                    'imgpath',
                    function() {
                      that.submitAxios()
                    }
                  )
                }
              )
            }
          )
        }
      )
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    },
    submitAxios: function() {
      var url = this.$ajax.setCreatorApplyInfo_URL,
        that = this,
        data = {
          territoryid: that.radio,
          cerimg: that.datalist[0],
          fansimg: that.datalist[1],
          cardfrontimg: that.datalist[2],
          cardhandimg: that.datalist[3],
          cardid: that.cardid,
          realname: that.realname
        },
        arg = isApp()
      if (that.info.id) data.id = that.info.id
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          this.$toast.clear()
          this.$dialog.close()
          // this.$toast(res.data.msg)
          setTimeout(function() {
            that.$router.replace('/submitsuccessful?verstatus=' + that.$route.query.verstatus + arg)
          }, 500)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.editAdd {
  background: #fea5a5;
  .title {
    height: 0.37rem;
    margin-top: 0.16rem;
  }
  ul {
    padding: 0.18rem 0.19rem;
    border-radius: 0 0.08rem 0.08rem 0.08rem;
    background: #fff;
    li {
      text-align: center;
      margin-bottom: 0.13rem;
      height: 1.66rem;
      position: relative;
      &.idcard {
        height: 0.41rem;
        width: 100%;
        background: #ffffff;
        border-radius: 0.08rem;
        border: 1px solid #fc0324;
        padding: 0.1rem;
        input {
          width: 100%;
          height: 100%;
          border-width: 0;
          outline: none;
          font-size: 0.15rem;
          &::placeholder {
            color: #6c6c6c;
          }
        }
        .close {
          width: 0.13rem;
          height: 0.13rem;
        }
      }
    }
    &.select {
      li {
        height: auto;
        .options {
          margin-top: 0.1rem;
          color: #292929;
          text-align: left;
          padding: 0.1rem;
          position: relative;
          .van-radio__icon--round .van-icon {
            background: url(/static/images/community/new-img/default.png) no-repeat center;
            background-size: 100%;
          }
          .van-radio__icon--checked .van-icon {
            background: url(/static/images/community/new-img/selected.png) no-repeat center;
            background-size: 100%;
          }
          .van-radio__label {
            color: #292929;
          }
          &.selected {
            color: #ffffff;
            .van-radio__label {
              color: #ffffff;
            }
            &:before {
              content: '';
              display: block;
              background: #fd3550;
              border: 1px solid #ffffff;
              border-radius: 0.08rem 0 0.08rem 0;
              position: absolute;
              width: 100%;
              height: 100%;
              left: 0;
              top: 0;
              z-index: 2;
            }
          }
          .img-icon {
            width: 0.2rem;
            height: 0.2rem;
          }
          &:before {
            content: '';
            display: block;
            background: #f4f8ff;
            border-radius: 0.08rem 0 0.08rem 0;
            border: 1px solid #fc0324;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 2;
          }
          &:after {
            content: '';
            display: block;
            position: absolute;
            left: 0.05rem;
            top: 0.05rem;
            z-index: 1;
            width: 100%;
            height: 100%;
            background: #fc0324;
            border-radius: 0.08rem 0 0.08rem 0;
          }
          p {
            font-weight: bold;
          }
          span {
            display: block;
            margin-top: 0.04rem;
          }
          &:first-of-type {
            margin-top: 0;
          }
          .van-radio {
            align-items: flex-start;
            z-index: 3;
            position: relative;
          }
        }
      }
    }
  }
  footer {
    height: 0.63rem;
    padding: 0.1rem 0.11rem;
    margin-top: 0.1rem;
    background: #ffffff;
    .btn {
      border: 0;
      outline: none;
      border-radius: 0.25rem;
      display: block;
      font-size: 0.17rem;
      color: #ffffff;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, #fc0324, #f63a66);
      background: -webkit-linear-gradient(90deg, #fc0324, #f63a66);
      background: -o-linear-gradient(90deg, #fc0324, #f63a66);
      background: -moz-linear-gradient(90deg, #fc0324, #f63a66);
      background: -ms-linear-gradient(90deg, #fc0324, #f63a66);
    }
  }
}
</style>
<style lang="scss">
.certification {
  ul {
    li {
      .content {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        height: 0.87rem;
        width: 1.7rem;
        overflow: hidden;
        border-radius: 0.04rem;
        img {
          width: 100%;
        }
      }
      .van-uploader__preview {
        position: absolute;
        left: 0.1rem;
        top: 0.1rem;
      }
      .van-uploader__input-wrapper {
        width: 2.74rem;
        height: 1.66rem;
        img {
          width: 100%;
        }
      }
      .options {
        .van-radio__icon--round .van-icon {
          border-width: 0;
          background: url(/static/images/community/new-img/default.png) no-repeat center;
          background-size: 100%;
        }
        .van-radio__icon--checked .van-icon {
          border-width: 0;
          background: url(/static/images/community/new-img/selected.png) no-repeat center;
          background-size: 100%;
        }
        .van-icon:before {
          display: none;
        }
        .van-radio__label {
          color: #292929;
        }
        &.selected {
          .van-radio__label {
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/certification.vue